<template lang="pug">
header#header
  nav.navbar.is-fixed-top(role="navigation" aria-label="main navigation")
    .navbar-brand
      a.navbar-item(href="/")
        img.logo(src="../assets/ixa.svg" width="120")
      a.navbar-burger.burger(@click="openMobileNav" role="button" aria-label="menu" aria-expanded="false" data-target="navMenu" :class="{'is-active': mobileNavState}")
        span(aria-hidden="true")
        span(aria-hidden="true")
        span(aria-hidden="true")
    #navManu.navbar-menu.navbar-mod(:class="{'is-active': mobileNavState}")
      .navbar-end
        .navbar-item
          .ixaNaviContainer
            ul.ixa_nav
              li.ixa_navItem
                router-link.button.is-small.is-dark.footer_navLink(to="/numbers3") NUMBERS3 
              li.ixa_navItem
                router-link.button.is-small.is-dark.footer_navLink(to="/numbers4") NUMBERS4 
              li.ixa_navItem
                router-link.button.is-small.is-dark.footer_navLink(to="/loto6") LOTO6 
              li.ixa_navItem
                router-link.button.is-small.is-dark.footer_navLink(to="/loto7") LOTO7
              li.ixa_navItem
                router-link.button.is-small.is-dark.footer_navLink(to="/history") 履歴 
</template>

<script>
export default {
  name: 'GlobalHeader',
  data(){
    return {
      isEditModalActive: false,
      mobileNavState: false,
      title: 'IXA | Numbers3 Numbers4 LOTO6 LOTO7',
      description: 'IXAは「ナンバーズ3、ナンバーズ4」や「ロト6、ロト7」をより楽しむ為の完全無料の選択数字ジェネレーターです。普段思いつかないような数字をランダムで生成し、購入予定数字の管理・記録も行えます。'
    }
  },
  computed: {
    isDisabled(){
      return this.$route.name == 'home' ? false : true
    }
  },
  methods: {
    openEditModalActivate(){
      this.isEditModalActive = true
    },
    openMobileNav(){
      this.mobileNavState = !this.mobileNavState 
    },
    async callCreateNumbers3(ev){
      ev.preventDefault()
      await this.$EventBus.$emit('ix3')
    },
    async callCreateNumbers4(ev){
      ev.preventDefault()
      await this.$EventBus.$emit('ix4')
    },
    async callCreateLoto6(ev){
      ev.preventDefault()
      await this.$EventBus.$emit('ix6')
    },
    async callCreateLoto7(ev){
      ev.preventDefault()
      await this.$EventBus.$emit('ix7')
    },
    modalClose(){
      this.mobileNavState = false 
      this.isEditModalActive = false 
    },
    createTitleAndDescription(to){
      // set title
      if(to.meta.title){
        var setTitle = to.meta.title
        document.title = setTitle
      }else{
        document.title = this.title
      }
      // set description
      if(to.meta.description){
        document.querySelector("meta[name='description']").setAttribute('content', to.meta.description)
      }else{
        document.querySelector("meta[name='description']").setAttribute('content', this.description)
      }
    }
  },
  mounted(){
    this.$EventBus.$on('naviClose', this.modalClose)
  },
  watch: {
    '$route' (to, from){
      this.createTitleAndDescription(to)
    }
  }
}
</script>

<style scoped lang="stylus">
#header
  .navbar
    .navbar-brand
      .navbar-item
        padding: 3px 0px 0px 10px!important
        .logo
          max-height: none!important
    #navManu
      &.is-active
        display: block
      .ixaNaviContainer
        .ixa_nav
          display: flex
          justify-content: center
          .ixa_navItem
            display: block 
            margin-left: 3px
            margin-right: 3px 
            line-height: 2em
            font-size: 0.7rem
      .znoContainer
        margin-top: 5px
        display: flex
        justify-content: center
        .ixaContainer
          margin-left: 20px
</style>
